import * as Immutable from 'immutable';
import * as React from 'react';
import { Grid } from 'semantic-ui-react';

import { Container } from '../../components';
import { BaseCompetitionsStoreElement } from '../../reducers/DashboardReducer/CompetitionsReducer/CompetitionsReducer.types';

import { Achievements } from './Achievements';
import { Alphas } from './Alphas';
import { Announcements } from './Announcements';
import { Competitions } from './Competitions';
import './Dashboard.scss';
import { Events } from './Events';
import { Notifications } from './Notifications';
import { Onboarding } from './Onboarding/Onboarding';
import ConsultantLeaderboard from '../Profile/UserProfile/ConsultantLeaderboard';
import GeniusCard from '../Profile/UserProfile/GeniusCard';

interface DashboardMainProps {
  country: string;
  dataCompetitions: Immutable.List<BaseCompetitionsStoreElement>;
  dataCompetitionsLevels: Immutable.Map<string, string>;
  userOnboardingData: Immutable.Map<string, string> | null;
  dashboardSections: string[];
  enabledIntro: boolean;
}

const sections: any = {
  notification: Notifications,
  achievements: Achievements,
  alphas: Alphas,
  events: Events,
  announcements: Announcements,
};

export function DashboardMain({
  country,
  dataCompetitions,
  dataCompetitionsLevels,
  userOnboardingData,
  dashboardSections,
  enabledIntro,
}: DashboardMainProps) {
  return (
    <section className="dashboard">
      <Container>
        <Grid className="grid-top no-padding-mobile grid__dashboard grid__col-3">
          {dashboardSections.map((element: string, index: number) => {
            if (element === 'competitions') {
              return (
                <Competitions
                  key={`dashboard-competition-${index}`}
                  data={dataCompetitions}
                  dataCompetitionsLevels={dataCompetitionsLevels}
                />
              );
            } else if (element === 'genius') {
              return <GeniusCard key="genius" isCurrentUser={true} />;
            } else if (element === 'onboarding' && userOnboardingData !== null) {
              return <Onboarding key="onboarding-section" data={userOnboardingData} country={country} />;
            } else if (element === 'consultant') {
              return <ConsultantLeaderboard key="consultant" />;
            } else {
              const Comp = sections[element];

              return <Comp key={`dashboard-sections-${index}`} enabledIntro={enabledIntro} />;
            }
          })}
        </Grid>
      </Container>
    </section>
  );
}

export default DashboardMain;
